var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2741 20.0962H12.9759L10.113 22.9665H7.25V20.0962H2V4.82218L3.42782 1H23V14.3703L17.2741 20.0962ZM21.0962 13.4184V2.91109H5.33891V16.7573H9.63703V19.6203L12.5 16.7573H17.75L21.0962 13.4184Z",
    fill: "#65459B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8389 6.73328V12.4665H17.75V6.73328H15.8389ZM10.5889 12.4592H12.5V6.73328H10.5889V12.4592Z",
    fill: "#65459B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.67ef2062.svg";
export { ForwardRef as ReactComponent };